import * as API from "./index.js"


const user_func_role = ""
const treeIDNull = "treeIDIsNull"
const menu_list = $_getMenu()
const head_icon = window.$config.head_icon
const login_icon = window.$config.login_icon
const login_head_icon = window.$config.login_head_icon
const home_head_icon = window.$config.home_head_icon
const home_head_icon_style = window.$config.home_head_icon_style


// async function getUserRoleFunc(server_env_id) {   //获取角色功能权限数据   处理返回
//       let response;
//       if(server_env_id){
//         let datas = {server_env_id: server_env_id}
//         response = await API.GET('/omnis/system/user_func_role', datas)
//       }else {
//         response = await API.GET('/omnis/system/user_func_role')
//       }
//       let data = response.data
//       var func_arr = []
//       if (data.success) {
//             data.data.map((items) =>{
//               var temp_dict = {}
//               if(items.env_id){
//                 temp_dict[items.env_id] = items.func_code
//               }else {
//                 temp_dict["func"] = items.func_code
//               }
//
//               func_arr.push(temp_dict)
//               // if(func_arr.indexOf(items.func_code) == -1){
//               //     func_arr.push(items.func_code)
//               // }
//               // if(env_arr.indexOf(items.env_id) == -1){
//               //     env_arr.push(items.env_id)
//               // }
//               // if(env_dict.hasOwnProperty(items.menu_id) && items.env_id){
//               //   env_dict[items.menu_id].push(items.env_id)
//               // }else if((!env_dict.hasOwnProperty(items.menu_id) )&& items.env_id){
//               //   env_dict[items.menu_id] = []
//               //   env_dict[items.menu_id].push(items.env_id)
//               // }
//
//             })
//       }
//       return func_arr
// };

async function $_getMenu(){
    const response = await API.GET('/omnis/system/user_role_menu')
    let menu_data = []
    if (response && response.data) {
      menu_data =  response.data.data
    }
    return menu_data
};




export default {
  user_func_role,
  treeIDNull,
  menu_list,
  head_icon,
  login_icon,
  login_head_icon,
  home_head_icon,
  home_head_icon_style,

}



// WEBPACK FOOTER //
// ./src/api/userFuncRole.js